export const isMobile = () => typeof window !== 'undefined' && window.innerWidth < 1024;

export const isTouchDevice = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  const mq = (query) => window.matchMedia(query).matches;
  // eslint-disable-next-line no-mixed-operators, no-undef
  if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
    return true;
  }
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
};

export const flatAndSort = (object, key) => {
  const keys = Object.keys(object);
  const sortedKeys = keys.sort((a, b) => object[a][key] - object[b][key]);
  const sortedObject = [];
  sortedKeys.forEach((k) => sortedObject.push({ key: k, ...object[k] }));
  return sortedObject;
};

export const isSafari = () => typeof navigator !== 'undefined' && navigator.vendor && navigator.vendor.indexOf('Apple') > -1
  && navigator.userAgent
  && navigator.userAgent.indexOf('CriOS') === -1
  && navigator.userAgent.indexOf('Chrome') === -1
  && navigator.userAgent.indexOf('FxiOS') === -1;

export const isIOS = () => !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

export const isEdge = () => typeof window !== 'undefined' && window.navigator.userAgent.indexOf('Edge') > -1;

export const isIE = () => typeof window !== 'undefined' && (window.navigator.userAgent.indexOf('MSIE') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1);

export const inApp = () => document.location.href.match(/app=true/gi);

export const inFullpage = () => document.location.href.match(/fullPage=true/gi);

export const getLang = () => {
  let m;

  if (inApp()) {
    m = document.location.href.match(/lang=(en|fr|es|it|de|jp|zh-Hans|kr)?/i);
  } else {
    const userLang = navigator.language || navigator.userLanguage;
    m = userLang.match(/(en|fr|es|it|de|jp|zh|kr)/i);
  }
  return m ? m[1] : 'en';
};

export const lerp = (a, b, n) => ((1 - n) * a) + (n * b);

/* eslint-disable quote-props, no-nested-ternary */
export const sendGAEvent = (action, label) => {
  console.log(`Sending GAEvent: %c${action} %c: %c${label}`, 'color: red', 'color: black', 'color: blue');
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event': 'generic_event',
    'eventCategory': inApp() ? 'app' : isMobile() ? 'mobile' : 'desktop',
    'eventAction': action,
    'eventLabel': label,
  });
};
